import { render, staticRenderFns } from "./FudouDetailComponent.vue?vue&type=template&id=29d45292&scoped=true"
import script from "./FudouDetailComponent.vue?vue&type=script&lang=js"
export * from "./FudouDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./FudouDetailComponent.vue?vue&type=style&index=0&id=29d45292&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d45292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29d45292')) {
      api.createRecord('29d45292', component.options)
    } else {
      api.reload('29d45292', component.options)
    }
    module.hot.accept("./FudouDetailComponent.vue?vue&type=template&id=29d45292&scoped=true", function () {
      api.rerender('29d45292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/sanjiang/FudouDetailComponent.vue"
export default component.exports